import React, { useState, useCallback, useEffect, ElementType } from 'react';
import { Box } from '@mui/material';
import {
  warehousesSelectors,
  getBasicWarehouses,
  setSelectedWarehouse,
  useDispatch,
  useSelector,
  clearSelectedWarehouse,
} from '../../../state';
import { useIsMobile } from '../../../hooks';
import { MobileModalForm } from '../../../themes/mobile/MobileModalForm';
import { FormModal, SelectInput } from '../..';

interface GlobalWarehouseSelectModalProps {
  onClose: () => void;
  open: boolean;
}

export const GlobalWarehouseSelectModal: React.FC<
  GlobalWarehouseSelectModalProps
> = ({ onClose, open }) => {
  const isMobile = useIsMobile();
  const dispatch = useDispatch();

  const warehouses = useSelector(warehousesSelectors.basicList);
  const selectedWarehouseId = useSelector(
    warehousesSelectors.selectedWarehouseId,
  );

  const [warehouseId, setWarehouseId] = useState<string | number>(
    selectedWarehouseId || '',
  );

  useEffect(() => {
    dispatch(getBasicWarehouses());
  }, [dispatch]);

  useEffect(() => {
    if (selectedWarehouseId) {
      setWarehouseId(selectedWarehouseId);
    }
  }, [selectedWarehouseId]);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setWarehouseId(e.target.value);
  }, []);

  const handleSave = useCallback(() => {
    if (warehouseId) {
      dispatch(setSelectedWarehouse(Number(warehouseId)));
    } else {
      dispatch(clearSelectedWarehouse());
    }
    onClose();
  }, [dispatch, warehouseId, onClose]);

  const ModalComponent: ElementType = isMobile ? MobileModalForm : FormModal;

  return (
    <ModalComponent
      open={open}
      handleClose={onClose}
      title='Select Warehouse'
      callback={handleSave}
      btnText='Save'
      {...(isMobile ? { handleCancel: onClose } : {})}
    >
      <Box sx={{ mb: 2 }}>
        <SelectInput
          variant='standard'
          label='Select warehouse'
          fullWidth
          name='warehouseId'
          value={warehouseId}
          onChange={handleChange}
          options={warehouses}
          autoFocus
          clearable
        />
      </Box>
    </ModalComponent>
  );
};
